<div class="header-sort" data-cy="list-header-wrap">
  <ng-container *ngFor="let item of sortItems; let first = first; let last = last; let i = index">
    <ng-container *ngIf="!(item.hasOwnProperty('show') && !item.show)">
      <app-resizable
        #resizable
        [class.sticky-field]="i <= 1"
        [class.last]="last"
        [class.first]="first"
        [isLast]="last"
        [isResize]="!!item?.isResizable"
        [ngStyle]="item?.styles?.flex && { flex: item?.styles?.flex }"
        [width]="item?.styles?.width"
        [min]="item?.styles?.min"
        [key]="item?.key"
        [isFlex]="!!item?.styles?.flex"
        [listElem]="listElem"
        (changedWidth)="changeWidth($event, item)">
        <div
          #column
          [class.active]="checkIfActive(item)"
          class="header-sort__item text-ellipsis"
          (click)="setActiveSort(item, $event)"
          data-cy="list-header-item">
          <ng-container *ngIf="!item?.headHtml; else htmlTemplate">
            <span class="description-padding">{{ item.description | translate }}</span>

            <div *ngIf="item.hasOwnProperty('iconClass')">
              <span [class.negative-sort]="checkIfNegativeState(item)" [ngClass]="getIconClass(item)"> </span>
            </div>
          </ng-container>

          <ng-template #htmlTemplate [ngTemplateOutlet]="item?.headHtml" [ngTemplateOutletContext]="{ item }"> </ng-template>
          @if (stickyOptions && last) {
            <div class="shadow absolute top-0 bg-transparent z-10 h-full"></div>
          }
        </div>
      </app-resizable>
    </ng-container>
  </ng-container>
</div>
